// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2NWUQ","secondary":"style_secondary__1LySs"};